import React from "react";
import { ArrowRight } from "lucide-react";
import AppStoreBadges from "./AppStoreBadges";
import { MAIN_APP_URL } from "../../lib/config";

export default function AppDownload() {
  return (
    <section
      id="get-the-app"
      className="py-24 md:py-32 bg-gradient-to-b from-cream-50 to-sage-50"
      data-testid="app-download"
    >
      <div className="max-w-4xl mx-auto px-5 lg:px-8 text-center">
        <p className="text-[11px] font-semibold tracking-[0.18em] uppercase text-sage-700">
          Get the app
        </p>
        <h2 className="font-display mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold text-moss-950 leading-[1.05] text-balance">
          Get the{" "}
          <span className="text-sage-600">Binshare</span>{" "}
          app.
        </h2>
        <p className="mt-5 text-lg text-moss-700 leading-relaxed max-w-xl mx-auto">
          Snap, quote, done — on iPhone, Android or the web. Whichever suits
          you.
        </p>

        <div className="mt-10">
          <AppStoreBadges align="center" />
        </div>

        <div className="mt-8">
          <a
            href={MAIN_APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-base font-semibold text-moss-900 hover:text-sage-700 transition-colors group"
            data-testid="webapp-link"
          >
            Or use the web app
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>
    </section>
  );
}
